import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import ConverterHero from './components/ConverterHero';
import ConverterFeatures from './components/ConverterFeatures';
import ConverterComparison from './components/ConverterComparison';
import ConverterTrial from './components/ConverterTrial';
import Footer from '../home/components/Footer';

export default function AdobePDFConverterPage() {
  const { t } = useTranslation();

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://documogul.com';
    
    document.title = 'Adobe PDF转换器 - 高性能文档格式转换工具 | 星允信息';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adobe PDF转换器提供高性能文档格式转换功能，支持PDF与Word、Excel、PowerPoint、图片等多种格式互转，保持原始格式和布局，批量处理，提升工作效率。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'PDF转换器,PDF转Word,PDF转Excel,文档格式转换,批量转换,Adobe转换器,PDF工具');
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/adobe-pdf-converter`);

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Adobe PDF转换器",
      "applicationCategory": "BusinessApplication",
      "description": "高性能文档格式转换工具，支持PDF与Word、Excel、图片等多种格式互转",
      "url": `${siteUrl}/adobe-pdf-converter`,
      "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "priceCurrency": "CNY",
        "price": "按需定制"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "65"
      },
      "provider": {
        "@type": "Organization",
        "name": "星允信息科技有限公司"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ConverterHero />
        <ConverterFeatures />
        <ConverterComparison />
        <ConverterTrial />
      </main>
      <Footer />
    </div>
  );
}